// import Account from '@/models/account'

const getters = {
  getAuthChain(state) {
    return state.currentAuthChain
  },
}

export default getters
